import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { AnagraficaDetailModalComponent } from './anagrafica-detail-modal';

export const AnagraficaDetailModalModule: string = ng
    .module('archiSmall.userSettings.anagraficaDetailModalModule', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('anagraficaDetailModalComponent', AnagraficaDetailModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/anagrafica-detail-modal/anagrafica-detail-modal.module.ts